<h1 mat-dialog-title>Confirmation</h1>
<div mat-dialog-content>
  <p>{{ data.message }}</p>
  <!-- You can also add dynamic text based on the type, if needed -->
  <!--<p>Record Type: {{data.type}}</p>-->
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onCancel()">No</button>
  <button mat-button (click)="onConfirm()">Yes</button>
</div>
